export const column = [
    {
        label: '账号',
        prop: 'account'
    },
    {
        label: '姓名',
        prop: 'name'
    },
    {
        label: '手机号',
        prop: 'phone'
    },
    {
        label: '单位',
        prop: 'twoUnit'
    },
    {
        label: '部门',
        prop: 'dept'
    },
    {
        label: '职务',
        prop: 'position'
    },
    {
        label: '注册时间',
        prop: 'insertDate'
    },
    {
        label: '状态',
        prop: 'status'
    },
]

export const errorColumn = [
    {
        label: '导入类型',
        prop: 'type'
    },
    {
        label: '异常文件名',
        prop: 'fileName'
    },
    {
        label: '异常所处行',
        prop: 'row'
    },
    {
        label: '异常所处列',
        prop: 'line'
    },
    {
        label: '异常原因',
        prop: 'details'
    },
    {
        label: '操作人',
        prop: 'insertName'
    },
    {
        label: '导入时间',
        prop: 'insertDate'
    }
]